import { render, staticRenderFns } from "./PlanTable.vue?vue&type=template&id=736af04d"
import script from "./PlanTable.vue?vue&type=script&lang=js"
export * from "./PlanTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports